export default __webpack_public_path__ + "static/media/criptos.ae15d8e8.png";